var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSharePermit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8C8.86396 8 10.375 6.48896 10.375 4.625C10.375 2.76104 8.86396 1.25 7 1.25C5.13604 1.25 3.625 2.76104 3.625 4.625C3.625 6.48896 5.13604 8 7 8ZM7 8C3.8934 8 1.375 10.5184 1.375 13.625V14.75H12.625C10.3468 14.75 8.5 12.9032 8.5 10.625C8.5 9.81428 8.73388 9.05818 9.13786 8.4205C8.47875 8.14947 7.75683 8 7 8ZM12.625 12.5C13.6605 12.5 14.5 11.6605 14.5 10.625C14.5 10.3121 14.4233 10.0171 14.2878 9.7577L11.7577 12.2878C12.0171 12.4233 12.3121 12.5 12.625 12.5ZM13.4923 8.96221L10.9622 11.4923C10.8267 11.2329 10.75 10.9379 10.75 10.625C10.75 9.58947 11.5895 8.75 12.625 8.75C12.9379 8.75 13.2329 8.82665 13.4923 8.96221ZM12.625 13.625C14.2819 13.625 15.625 12.2819 15.625 10.625C15.625 8.96815 14.2819 7.625 12.625 7.625C10.9681 7.625 9.625 8.96815 9.625 10.625C9.625 12.2819 10.9681 13.625 12.625 13.625Z",
    fill: "#F53F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSharePermit);
export default __webpack_public_path__ + "static/media/NoSharePermit.16499d54d2d40074b6c059a14399448c.svg";
export { ForwardRef as ReactComponent };